module.exports = __webpack_public_path__ + "static/media/error.450d0ca6.svg";